import classNames from 'classnames';
import { type ComponentPropsWithRef, type ElementType, forwardRef } from 'react';
import { Text } from '../../atoms/text/text';
import { Label } from '../label/label';
import { FieldFooter, type FieldFooterState } from '../legacy-field-footer/field-footer';
import styles from './textarea.module.scss';

export type TextareaProps = ComponentPropsWithRef<'textarea'> & {
  bold?: boolean;
  className?: string;
  icon?: ElementType;
  label?: string;
  statusLabel?: string;
  statusType?: FieldFooterState;
  subLabel?: string;
};

/**
 * Ref needs to be forwarded to be compatible with form packages like react-hook-form.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, disabled, icon, label, name, statusLabel, statusType = 'default', subLabel, ...props }, ref) => {
    const labelId = name && `${name}_label`;
    const statusId = name && `${name}_validationMessage`;

    return (
      <div className={classNames(styles.wrapper, className)}>
        {Boolean(label) && (
          <Label bold htmlFor={name ?? ''} id={labelId}>
            {label}
            {Boolean(subLabel) && (
              <Text className={styles['sub-label']} size="xs">
                {subLabel}
              </Text>
            )}
          </Label>
        )}
        <div
          className={classNames(
            styles['input-row'],
            disabled && styles['input-row-disabled'],
            statusType !== 'default' && styles[`input-row-${statusType}`],
          )}
        >
          <textarea
            {...props}
            aria-describedby={statusId}
            aria-invalid={statusType === 'error'}
            aria-labelledby={labelId}
            disabled={disabled}
            name={name}
            ref={ref}
          />
        </div>
        {Boolean(statusLabel) && <FieldFooter icon={icon} id={statusId} label={statusLabel} state={statusType} />}
      </div>
    );
  },
);
